import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import pdfjs from 'pdfjs-dist'
import jsPDF from 'jspdf'

Vue.config.productionTip = false

Vue.prototype.$axios = axios
Vue.prototype.$pdfjs = pdfjs
Vue.prototype.$jsPDF = jsPDF

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$axios.defaults.headers.common['Content-Type'] = 'application/json'
  Vue.prototype.$axios.defaults.headers.common['GSDAuthorization'] = token
  // if (process.env.VUE_APP_MODE === 'development') {
  //   Vue.prototype.$axios.defaults.headers.common['XDEBUG_SESSION_START'] = 'PHPSTORM'
  // }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
